import { useCallback } from 'react';
import styled from 'styled-components';
import { getThemeColor } from '../../customHostConfigOnClient';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-basis: ${(props) => (props.$flexBasis || '100%')};
`;

const InputWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  background-color: ${(props) => (props.disabled ? '#f8f8f8' : 'white')};
  border-radius: 10px;
`;

const InputBase = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 10px;

  /* Remove iOS Safari's default bevels & shadows */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-clip: padding-box; /* Fix subtle gradient edges */

  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10);
  border: ${(props) =>
    props.disabled ? 'none' : `1px solid ${props.$hasError ? 'red' : '#ccc'}`};
  font-size: 15px;
  font-family: ${(props) => props.$fontFamily || 'Arial, sans-serif'};
  // adjust the border color for the input when it's selected
  &:focus {
    border-color: ${() => getThemeColor()};
    box-shadow: ${() => `0 0 5px ${getThemeColor()}`};
    outline: none; // Remove default focus styles
  }
`;

const EndAdornmentWrapper = styled.div`
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Error = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;

export const TextInput = (props) => {
  const {
    value,
    onChange,
    error,
    placeholder,
    endAdornment,
    disabled = false,
    ...others
  } = props;

  const handleChange = useCallback(
    (e) => {
      const { value, name } = e.target;
      onChange?.(value, name);
    },
    [onChange]
  );

  return (
    <InputContainer {...others}>
      <InputWrapper disabled={disabled}>
        <InputBase
          type="text"
          placeholder={placeholder}
          value={value || ''}
          onChange={handleChange}
          $hasError={error}
          disabled={disabled}
          {...others}
        />
        {endAdornment && (
          <EndAdornmentWrapper>{endAdornment}</EndAdornmentWrapper>
        )}
      </InputWrapper>
      {error && <Error>{error}</Error>}
    </InputContainer>
  );
};
